<div class="custom-container">
  @if (signedOutInAnotherTab()) {
    <div role="alert" class="alert alert-warning m-3">
      Du er logget ud i en anden fane. Kopiér eventuelle ændringer, før du forlader siden.
      <a href="/">Gå til forsiden</a>
    </div>
  }
  @let session = sessionData$ | async;
  @let revoked = accessRevoked(session);
  @if (session?.initialized) {
    <app-store-impersonation-header></app-store-impersonation-header>
    <app-menu></app-menu>
  }
  @if (revoked) {
    <main class="container py-5">
      <h1>Din adgang er ændret</h1>
      <p>Du har ikke længere adgang til denne side. Siden forbliver åben, mens du er her.</p>
      <a routerLink="/landing">Gå til dine tilgængelige funktioner</a>
    </main>
  }
  <div class="route-content" [hidden]="revoked">
    <router-outlet />
  </div>
</div>
